import Phaser from 'phaser'

export default class GameOverScene extends Phaser.Scene{
    constructor(){
        super('game-over-scene')
    }
    init(){
        this.replayButton = undefined
    }

    preload(){
        this.load.image('gameoverbackground', 'images/gameover.png')
        this.load.image('replaybutton', 'images/replayButton2.jpg')
        this.load.audio('gameoversound', 'sound/gameovermusic.mp3')
    }

    create(){
        const gameWidth = this.scale.width * 0.5
        const gameHeight = this.scale.width * 0.5
        this.add.image(gameWidth, gameHeight, 'gameoverbackground')
    
        this.replayButton = this.add.image(gameWidth,420, 'replaybutton').setScale(0.2).setInteractive()
        
        this.replayButton.once('pointerup', () => {this.scene.start('knight-game-scene')}, this)
        this.sound.play('gameoversound')
    }
}